"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _FormulaMember = _interopRequireDefault(require("../FormulaMember"));
var _errors = _interopRequireDefault(require("../../errors"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var ContributionBlock = function ContributionBlock(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var labels = props.labels,
    data = props.data,
    thresholdIndex = props.thresholdIndex,
    errors = props.errors,
    ruleIndex = props.ruleIndex;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(R.path([thresholdIndex, 'contribution', 'formulaItems', 'generic'], errors) ? 'formula-empty-error-container' : '', " threshold-contribution threshold-block")
  }, /*#__PURE__*/_react["default"].createElement("strong", {
    className: "threshold-element threshold-header"
  }, (0, _utils.toUpper)(labels.PENSION_PENSIONABLE_SALARY_THEN_LABEL)), /*#__PURE__*/_react["default"].createElement("span", {
    className: "threshold-element"
  }, labels.PENSION_PENSIONABLE_SALARY_CONTRIBUTION_LABEL), !(0, _utils.isBlank)(R.path(['contribution', 'formulaItems'], data)) && data.contribution.formulaItems.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_FormulaMember["default"], _extends({}, props, {
      member: item,
      noDelete: index === 0 && item.type !== 'function',
      ruleIndex: ruleIndex,
      key: item.key,
      keysPath: [thresholdIndex, 'contribution', 'formulaItems', index]
    }));
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "threshold-element contribution-element"
  }, labels.PENSION_CONTRIBUTION_OF_PENSIONABLE), R.path([thresholdIndex, 'contribution', 'formulaItems', 'generic'], errors) && /*#__PURE__*/_react["default"].createElement(_errors["default"], {
    className: "formula-empty-error-label",
    message: R.path([thresholdIndex, 'contribution', 'formulaItems', 'generic'], errors)
  }));
};
ContributionBlock.defaultProps = {
  errors: {},
  disabled: false
};
ContributionBlock.propTypes = {
  disabled: _propTypes["default"].bool,
  /* The threshold index */
  thresholdIndex: _propTypes["default"].number.isRequired,
  /* The rule index */
  ruleIndex: _propTypes["default"].number.isRequired,
  /* The rewards labels */
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  /* The root data for each threshold */
  data: _propTypes["default"].shape({}).isRequired,
  /* The errros object */
  errors: _propTypes["default"].shape({})
};
var _default = exports["default"] = ContributionBlock;